/**
 * Semantic linter rules for AudioStreamPlayer (non-positional).
 *
 * A streamless player is valid, since the stream can be set at runtime, so only
 * autoplay over an empty slot is reported.
 */
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { resourceSlotIsEmpty } from '../../../linter/resourceChecker.js';
import { isDrivenByAnimationAudioTrack } from '../sharedLinterChecks.js';
import { boolSlotValue } from '../../../godot/variant/variantBool.js';
import { armEmits, groundedArm, reportArm } from '../../../linter/ruleArms.js';
const arms = {
    autoplayWithoutStream: groundedArm('audiostreamplayer-autoplay-without-stream', {
        kind: 'engine-inert',
        at: 'audio_stream_player_internal.cpp:139',
        unused: 'play_basic returns an empty playback, so autoplay produces no sound',
    }),
};
function checkAudioStreamPlayer(context) {
    const diagnostics = [];
    const { node, scene } = context;
    const rawProps = node.rawProperties;
    // Autoplay with no stream. Godot raises no warning: `play_basic()`
    // (audio_stream_player_internal.cpp:137-141) returns a null playback when `stream` is null and
    // logs nothing. Suppressed when an AnimationPlayer audio track drives this node instead.
    if (boolSlotValue(rawProps.autoplay) === true &&
        resourceSlotIsEmpty(rawProps.stream) &&
        !isDrivenByAnimationAudioTrack(scene, node)) {
        reportArm(diagnostics, arms.autoplayWithoutStream, node, `Autoplay is enabled but no stream is set. The player will have no audio source.`);
    }
    return diagnostics;
}
const audioStreamPlayerValidationRule = {
    meta: {
        name: 'valid-audiostreamplayer-properties',
        description: 'Validates AudioStreamPlayer property values and logical consistency (non-positional node)',
        category: 'validation',
        applicableNodeTypes: ['AudioStreamPlayer'],
        emits: armEmits(arms),
    },
    check: checkAudioStreamPlayer,
};
ruleRegistry.register(audioStreamPlayerValidationRule);
//# sourceMappingURL=linter.js.map